import { GeneralSettingsTab } from './GeneralSettingsTab';

export default GeneralSettingsTab;



// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/GeneralSettingsTab/index.ts